import React, { useState, useEffect, useLayoutEffect, useCallback } from 'react';
import Avatar from '@mui/material/Avatar';
import CircularProgress from '@mui/material/CircularProgress'; // ✅ loader
import SearchInput from '../../../components/common/SearchInputField';
import ButtonMain from '../../../components/common/ButtonMain';
import { Box, Skeleton } from '@mui/material';
import { ReactComponent as Copy } from '../../../assets/images/ChatImages/copy.svg';
import { ReactComponent as Edit } from '../../../assets/images/ChatImages/edit.svg';
import { ReactComponent as Delete } from '../../../assets/images/ChatImages/delete.svg';
import CannedPopup from './CannedPopup';
import { getAllCanned } from '../../../store/features/getAllCanned';
import { deleteCanned } from '../../../store/features/deleteCanned';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import './style.css';
import {
  getCannedResponsesWarmCache,
  setCannedResponsesWarmCache,
} from '../../../utils/cannedResponsesWarmCache';

function businessIdsMatch(cachedId, currentId) {
  if (cachedId == null || currentId == null) return false;
  return String(cachedId) === String(currentId);
}

const chracterPosition = (alphabet) => {
  const alphabets = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
  const positionOfAlphabet = alphabets.indexOf(alphabet) + 1;
  return positionOfAlphabet;
};

const colorCodesForAvatar = [
  '#405261', '#FF4D4F', '#FA541C', '#FA8C16', '#FAAD14', '#EB2F96',
  '#FADB14', '#A0D911', '#52C41A', '#5CDBD3', '#9254DE', '#F759AB',
  '#2F54EB', '#722ED1', '#1890FF', '#13C2C2', '#2DB7F5', '#19BE6B',
  '#30A745', '#FA8C16', '#FAAD14', '#9254DE', '#F759AB', '#13C2C2',
  '#722ED1', '#2DB7F5',
];

function CannedResponse() {
  const [visibleRows, setVisibleRows] = useState(4);
  const [searchQuery, setSearchQuery] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [data, setData] = useState([]);
  const [selectedMsg, setSelectedMsg] = useState('');
  const [selectedTab, setSelectedTab] = useState('all');
  const [cannedResponse, setCannedResponse] = useState(false);
  const [cannedPrivate, setCannedPrivate] = useState(false);
  const [cannedMsg, setCannedMsg] = useState('');
  const [cannedTag, setCannedTag] = useState('');
  const [loading, setLoading] = useState(false); // ✅ new loading state

  const dispatch = useDispatch();
  const userData = useSelector((state) => state.loginToken);
  const businessId = userData?.response?.user?.business_id;

  const currentLanguage = useSelector((state) => state.language.currentLanguage);
  const t = useSelector((state) => state.language.translations[currentLanguage]);

  const getCanned = useCallback(
    async (options = {}) => {
      const { background = false } = options;
      if (!businessId) return;
      if (!background) setLoading(true);
      const listCoUserList = dispatch(getAllCanned({ id: businessId }));
      listCoUserList
        .then(async (data) => {
          if (!background) setLoading(false);
          if (!data.payload) {
            toast.error('Some Error Occured. Please try again later.');
          } else if (data?.payload?.success) {
            const next = data.payload.data;
            setData(next);
            setCannedResponsesWarmCache({
              businessId,
              data: next,
              hasFetched: true,
            });
          } else {
            toast.error('Some Error Occured. Please try again later.');
          }
        })
        .catch(async (error) => {
          if (!background) setLoading(false);
          toast.error(error);
        });
    },
    [businessId, dispatch]
  );

  useLayoutEffect(() => {
    if (!businessId) return;
    const wc = getCannedResponsesWarmCache();
    if (
      wc.hasFetched &&
      businessIdsMatch(wc.businessId, businessId) &&
      Array.isArray(wc.data)
    ) {
      setData(wc.data);
      setLoading(false);
      void getCanned({ background: true });
    } else {
      void getCanned({ background: false });
    }
  }, [businessId, getCanned]);

  const handleSearchInputChange = (e) => {
    const query = e.target.value.toLowerCase();
    setSearchQuery(query);
    const filteredResults = data.filter((item) =>
      item.content.toLowerCase().includes(query)
    );
    setFilteredData(filteredResults);
  };

  const handleDeleteCanned = (id) => {
    const listCoUserList = dispatch(deleteCanned({ id }));
    listCoUserList
      .then(async (data) => {
        if (!data.payload) {
          toast.error('Some Error Occured. Please try again later.');
        } else if (data?.payload?.success) {
          void getCanned({ background: true });
          toast.success('Deleted Successfully');
        } else {
          toast.error('Some Error Occured. Please try again later.');
        }
      })
      .catch(async (error) => {
        toast.error(error);
      });
  };

  const handleTabChange = (newValue) => {
    setSelectedTab(newValue);
  };

  useEffect(() => {
    const newFilteredData = data.filter((item) =>
      selectedTab === 'all' ? true :
        selectedTab === 'shared' ? !item.is_private :
          item.is_private
    );
    setFilteredData(newFilteredData);
    setSearchQuery('');
  }, [data, selectedTab]);

  const handleViewMore = () => {
    setVisibleRows(visibleRows + 4);
  };

  const formatDate = (dateString) => {
    const options = { day: 'numeric', month: 'long', year: 'numeric' };
    return new Date(dateString).toLocaleDateString('en-GB', options);
  };

  const handleCopy = (text) => {
    navigator.clipboard.writeText(text);
  };
  console.log('filtrr', filteredData)
  return (
    <div className="canned-main">
      <p className="canned-response">{t.CANNEDRESPONSE}</p>
      <p className="canned-review-response">{t.REVIEWRESPONSES}</p>

      {cannedResponse && (
        <CannedPopup
          selectedMsg={selectedMsg}
          setSelectedMsg={setSelectedMsg}
          cannedPrivate={cannedPrivate}
          cannedMsg={cannedMsg}
          cannedTag={cannedTag}
          setCannedResponse={setCannedResponse}
          getCanned={getCanned}
        />
      )}

      <div className="canned-listing">
        <SearchInput
          title=""
          placeholder="Search"
          className="search-input-canned"
          value={searchQuery}
          onChange={handleSearchInputChange}
        />
        <ButtonMain
          className="new-canned-response"
          onClick={() => {
            setCannedResponse(true);
            setCannedPrivate(false);
            setCannedMsg('');
            setCannedTag('');
            setSelectedMsg('');
          }}
          title={t.NEWCANNEDRESPONSE}
        />
      </div>

      <div className="custom-tabs-container">
        <div>
          <button
            className={`custom-tab ${selectedTab === 'all' ? 'selected' : ''}`}
            onClick={() => handleTabChange('all')}
          >
            All
          </button>
          <button
            className={`custom-tab ${selectedTab === 'shared' ? 'selected' : ''}`}
            onClick={() => handleTabChange('shared')}
          >
            Shared
          </button>
          <button
            className={`custom-tab ${selectedTab === 'private' ? 'selected' : ''}`}
            onClick={() => handleTabChange('private')}
          >
            Private
          </button>
        </div>
        <p className="canned-msg-count">({filteredData.length}) canned responses</p>
      </div>

      {/* ✅ Skeletons instead of spinner */}
      {loading ? (
        <div style={{ marginTop: '37px' }} className="canned-grid">
          {[...Array(4)].map((_, i) => (
            <Box key={i} className="canned-msg-box">
              <div className="canned-box-top">
                <Skeleton variant="text" width={100} height={20} />
                <Skeleton variant="rectangular" width={60} height={20} />
              </div>
              <div className="canned-box-mid">
                <Skeleton variant="text" width="90%" height={20} />
                <Skeleton variant="text" width="80%" height={20} />
              </div>
              <div className="canned-box-bottom" style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                <Skeleton variant="circular" width={24} height={24} />
                <Skeleton variant="text" width={140} height={20} />
              </div>
            </Box>
          ))}
        </div>
      ) : (
        <>

          <div className="canned-grid">
            {filteredData.map((item) => (
              <Box key={item._id} className="canned-msg-box">
                <div className="canned-box-top">
                  <span style={{ fontWeight: '500' }}><span style={{ color: '#148DFD' }}>#</span> {item?.tagDetails?.tag}</span>
                  <p className="icons-container">

                    <Edit
                      onClick={() => {
                        setSelectedMsg(item._id);
                        setCannedResponse(true);
                        setCannedPrivate(item.is_private);
                        setCannedMsg(item.content);
                        setCannedTag(item?.tagDetails?.tag);
                      }}
                      style={{ cursor: 'pointer', margin: '0 8px' }}
                    />
                    <Copy style={{ cursor: 'pointer' }} onClick={() => handleCopy(item.content)} />
                    <Delete
                      onClick={() => handleDeleteCanned(item._id)}
                      style={{ cursor: 'pointer' }}
                    />
                  </p>
                </div>
                <div className="canned-box-mid">
                  {item.content}
                </div>
                <div className="canned-box-bottom">
                  {item?.
                    userDetails
                    ?.agent_image && item?.
                      userDetails
                      .agent_image.trim() !== "" ? (
                    <Avatar
                      src={item?.
                        userDetails
                        ?.agent_image}
                      alt="users logo"
                      style={{ width: '24px', height: '24px', }}
                    />
                  ) : (
                    <Avatar
                      style={{ width: '24px', height: '24px', fontSize: '14px' }}
                      sx={{
                        bgcolor: colorCodesForAvatar[
                          chracterPosition(item.userDetails?.full_name?.substring(0, 1).toUpperCase() || 'A')
                        ],
                      }}
                    >
                      {item.userDetails?.full_name?.substring(0, 1).toUpperCase() || 'A'}
                    </Avatar>
                  )}
                  Added by {item?.userDetails?.full_name}, {formatDate(item.createdAt)}
                </div>
              </Box>
            ))}
          </div>
          {/* <div className="canned-view-more">
            {visibleRows < filteredData.length && (
              <p className="view-more-text" onClick={handleViewMore}>
                {t.VIEWMO}
              </p>
            )}
          </div> */}
        </>
      )}
    </div>
  );
}

export default CannedResponse;